/**
 * SM-2 算法实现
 * 参考: https://en.wikipedia.org/wiki/SuperMemo#Algorithm_SM-2
 */

/**
 * 计算下次复习时间
 * @param {Object} review - 当前复习记录
 * @param {number} quality - 复习质量 (0-5)
 * @param {Object} settings - 复习设置
 * @returns {string} - 下次复习时间
 */
export function calculateNextReview(review, quality, settings) {
  // 计算 EF (Easiness Factor)
  let ef = review.ef || 2.5
  ef = Math.max(1.3, ef + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02)))
  
  // 计算间隔
  let interval
  if (!review.lastReview) {
    // 新笔记
    interval = settings.initialInterval
  } else if (!review.interval) {
    // 第一次复习
    interval = 6
  } else {
    // 后续复习
    interval = Math.round(review.interval * ef * settings.intervalModifier)
  }
  
  // 如果质量小于3，重置为初始间隔
  if (quality < 3) {
    interval = settings.initialInterval
  }
  
  // 计算下次复习日期
  const nextDate = new Date()
  nextDate.setDate(nextDate.getDate() + interval)
  
  return {
    nextReview: nextDate.toISOString(),
    interval: interval,
    ef: ef
  }
}

/**
 * 获取复习质量描述
 * @param {number} quality - 复习质量 (0-5)
 * @returns {string} - 质量描述
 */
export function getQualityDescription(quality) {
  const descriptions = {
    0: '完全不记得',
    1: '记错了',
    2: '记得很模糊',
    3: '记得有点困难',
    4: '记得比较清楚',
    5: '记得非常清楚'
  }
  return descriptions[quality] || ''
}

/**
 * 计算记忆效率
 * @param {Array} reviews - 复习记录数组
 * @returns {number} - 记忆效率百分比
 */
export function calculateEfficiency(reviews) {
  if (!reviews.length) return 0
  
  const goodReviews = reviews.filter(r => r.quality >= 3).length
  return (goodReviews / reviews.length * 100).toFixed(1)
} 